import { io } from "socket.io-client";
const socket = io("voice.atlaskit.app");
// const socket = io("wss://139.162.171.227:3000");
// const socket = io("ws://192.168.43.77:3000");

// @ts-ignore
socket.request = function request(type, data = {}) {
  return new Promise((resolve, reject) => {
    socket.emit(type, data, (data:any) => {
      if (data?.error) {
        reject(data?.error);
      } else {
        resolve(data);
      }
    });
  });
};

export default socket
